import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { merge, Subject, timer } from 'rxjs';
import { debounce, mapTo } from 'rxjs/operators';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'name-tag',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './name-tag.component.html',
  styleUrls: ['./name-tag.component.scss'],
})
export class NameTagComponent implements OnDestroy {
  @Input() user;
  @Input() showOrg = true;
  @Input() link = false;
  @Input() hint = false;
  @Input() postfix = '';
  @Input() size: 'small' | 'medium' = 'small';

  active = false;
  in = new Subject<void>();
  out = new Subject<void>();
  close = new Subject<void>();
  sub = merge(
    this.in.pipe(mapTo('IN')),
    this.out.pipe(mapTo('OUT')),
    this.close.pipe(mapTo('CLOSE')),
  )
    .pipe(debounce(_ => timer(_ === 'IN' ? 1000 : _ === 'OUT' ? 200 : 0)))
    .subscribe(_ => (this.active = _ === 'IN'));

  constructor(
    private modal: NgbModal,
    private router: Router,
  ) {}

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  closeModals() {
    this.close.next();
    // this.modal.dismissAll();
  }

  clicked(event) {
    if (this.link) {
      event.stopPropagation();
      event.preventDefault();

      window.open(
        this.router.serializeUrl(
          this.router.createUrlTree([`/profile/${this.user._id}`]),
        ),
        '_blank',
      );
    }
  }
}
